import { render, staticRenderFns } from "./mb-header.vue?vue&type=template&id=d142d672&scoped=true&"
import script from "./mb-header.vue?vue&type=script&lang=js&"
export * from "./mb-header.vue?vue&type=script&lang=js&"
import style0 from "./mb-header.vue?vue&type=style&index=0&id=d142d672&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d142d672",
  null
  
)

export default component.exports